document.addEventListener('click', (e) => {
    if (e.target.closest('.cat-filter')) {
        const catFilters = document.querySelectorAll('.cat-filter')
        catFilters.forEach((catFilter) => catFilter.classList.remove('active'))

        const catFilter = e.target.closest('.cat-filter')
        const filterValue = catFilter.dataset.value
        const postListing = catFilter.closest('.pc-post-listing')
        const postContainer = postListing.querySelector('.post-listing')
        const loadMoreBtn = postListing.querySelector('.load-more')
        if (loadMoreBtn) {
            loadMoreBtnText = loadMoreBtn.querySelector('.load-more-text')
            loadMoreBtn.dataset.catId = filterValue
        }

        const data = new FormData()
        data.append('action', 'load_more')
        data.append('security', liGlobal.loadMore)

        data.append('cat_id', filterValue)
        data.append('post_type', 'post')

        // Listningens fasta kategoriurval. Måste med även här — annars visar
        // "Alla" hela bloggen i stället för bara de valda kategorierna.
        const listingCategories = catFilter.closest('[data-listing-categories]')?.dataset.listingCategories || ''
        if (listingCategories) {
            data.append('categories', listingCategories)
        }

        if (loadMoreBtn) {
            data.append('card_class', loadMoreBtn.dataset.cardClass)
            data.append('card_body', loadMoreBtn.dataset.cardBody)
        }

        fetch(liGlobal.ajaxUrl, {
            method: 'POST',
            body: data,
        })
            .then((response) => response.text())
            .then((response) => {
                response = JSON.parse(response)
                if (!response.success) {
                    return
                }
                catFilter.classList.add('active')
                if (loadMoreBtn) {
                    // Listan byggs om från början — nollställ pagineringen, annars
                    // tror knappen att den redan står på sidan den stod på före bytet.
                    loadMoreBtn.dataset.paged = '1'
                    loadMoreBtn.dataset.maxPages = response.data.max_num_pages?.toString() || ''

                    // Läs flaggan, inte texten: texten kommer på svenska från PHP
                    // och den gamla jämförelsen mot 'No more posts' slog aldrig till.
                    const noMore = response.data.no_more_posts || response.data.max_num_pages <= 1

                    if (noMore) {
                        loadMoreBtn.setAttribute('disabled', 'disabled')
                        loadMoreBtn.classList.remove('loading')
                        loadMoreBtn.style.display = 'none'
                    } else {
                        loadMoreBtn.removeAttribute('disabled')
                        loadMoreBtn.style.display = ''
                    }

                    loadMoreBtnText.textContent = response.data.load_more_btn_text
                }

                const posts = response.data.posts
                postContainer.innerHTML = ''
                posts.forEach((post) => {
                    postContainer.insertAdjacentHTML('beforeend', post)
                })
            })
    }
})
